export enum MapStyle {
	LIGHT = "LIGHT",
	DARK = "DARK",
	SATELLITE = "SATELLITE",
	NONE = "NONE",
}

export enum MapSlotLayerId {
	DRAW = "draw-slot",
	SELECTION = "selection-slot",
	ASSETS = "assets-slot",
	PROJECT_BOUNDS = "project-bounds-slot",
	PROJECT_FILES = "project-files-slot",
}

export enum GeometryDrawMode {
	POLYGON = "polygon",
	LINE = "line",
	POINT = "point",
	RECTANGLE = "rectangle",
	CIRCLE = "circle",
	SECTOR = "sector",
	ELLIPSE = "ellipse",
	DISC = "disc",
	DIAMOND = "diamond",
}

export enum GeometryEditMode {
	MOVE = "scale",
	EDIT = "edit",
}
